/* @flow */
import React from 'react';
import styled from 'styled-components';

import FlexBox from '../../FlexBox';

const StyledBox = styled(FlexBox)`
  /* stylelint-disable no-descending-specificity */
  align-items: center;
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? '0px' : '20px')};
  label {
    color: #666;
    font-size: 14px;
    width: 160px;
  }

  &.inline {
    margin-bottom: 20px;

    label {
      width: auto;
      margin-right: 20px;
    }
  }

  .ant-select {
    width: 100%;
  }

  &.fixed-width {
    .ant-input,
    .ant-select {
      width: 260px;
    }
  }
  &.text-right {
    text-align: right;
  }

  .input-field {
    flex: 1;
    position: relative;

    .error-msg {
      position: absolute;
      bottom: -18px;
      left: 0;
      color: #ef4b5a;
    }
  }
  .desc {
    a {
      color: #f0b90b;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .ant-input,
  .ant-select-selection {
    color: #333;
    border-color: ${({ hasError }) => (hasError ? '#ef4b5a' : '#d9d9d9')};
  }

  .ant-input:focus,
  .ant-select-selection:focus,
  .ant-select-selection:active,
  .ant-select-focused .ant-select-selection {
    box-shadow: ${({ hasError }) => (hasError ? 'none' : '0 0 0 2px rgba(240, 185, 11, 0.2)')};
  }

  .ant-input:hover,
  .ant-select-selection:hover,
  .ant-input:focus,
  .ant-select-selection:focus,
  .ant-select-selection:active,
  .ant-select-focused .ant-select-selection {
    border-color: ${({ hasError }) => (hasError ? '#ef4b5a' : '#f0b90b')};
  }
  .ant-select-arrow {
    color: ${({ hasError }) => (hasError ? '#ef4b5a' : '#f0b90b')};
    transform: translateY(-50%);
    margin-top: 0;
    font-size: 14px;
  }

  /* stylelint-enable */
`;

type StyledInputProps = {
  label: string,
  errorMsg: string,
  customStyle: Object,
  children: any,
};

/* eslint-disable jsx-a11y/label-has-for */
const FormItem = ({
  label, errorMsg, customStyle, children, ...others
}: StyledInputProps) => (
  <StyledBox hasError={!!errorMsg} {...customStyle} {...others}>
    <label htmlFor={label}>{label && `${label}:`}</label>
    <div className="input-field">
      {children}
      <span className="error-msg">{errorMsg}</span>
    </div>
  </StyledBox>
);

export default FormItem;
